export default __webpack_public_path__ + "static/media/package-7.f29b481a.svg";